module.exports = {
    rank: 15,
    darkTileLink:
    'https://api.mapbox.com/styles/v1/jackhou/ciwwyxvrn00s32qqobx5rdmbm/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamFja2hvdSIsImEiOiJYTFBNUWZrIn0.PypRvvJ-gu46VjJTpAolMw',
    commomTileLink:
    'https://api.mapbox.com/styles/v1/jackhou/ciwwy7kh200rz2qqoyj2jnwil/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamFja2hvdSIsImEiOiJYTFBNUWZrIn0.PypRvvJ-gu46VjJTpAolMw',
    makiToken:
    'pk.eyJ1IjoiamFja2hvdSIsImEiOiJYTFBNUWZrIn0.PypRvvJ-gu46VjJTpAolMw',
};
